import { render } from "./CreditRequest.vue?vue&type=template&id=9fa33884&scoped=true"
import script from "./CreditRequest.vue?vue&type=script&lang=js"
export * from "./CreditRequest.vue?vue&type=script&lang=js"

import "./CreditRequest.vue?vue&type=style&index=0&id=9fa33884&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa33884"],['__file',"src/views/CreditRequests/CreditRequest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9fa33884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fa33884', __exports__)) {
    api.reload('9fa33884', __exports__)
  }
  
  module.hot.accept("./CreditRequest.vue?vue&type=template&id=9fa33884&scoped=true", () => {
    api.rerender('9fa33884', render)
  })

}


export default __exports__